package uz.ferro.erp.feature.product.ui

import HeaderTitleView
import kotlinx.browser.window
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import mui.material.Box
import mui.material.CircularProgress
import mui.material.Grid
import mui.system.responsive
import mui.system.sx
import react.FC
import react.create
import react.router.dom.useSearchParams
import react.useContext
import react.useEffect
import react.useEffectOnce
import react.useState
import uz.ferro.erp.NavigationContext
import uz.ferro.erp.feature.product.data.ProductManager
import uz.ferro.erp.feature.product.model.Product
import uz.ferro.erp.ui.GenericPage
import uz.ferro.erp.ui.VerticalLayout
import uz.ferro.erp.util.lg
import uz.ferro.erp.util.localized
import uz.ferro.erp.util.md
import uz.ferro.erp.util.sm
import uz.ferro.erp.util.xs
import web.cssom.AlignItems
import web.cssom.JustifyContent
import web.cssom.px

val ProductListPage = FC {
    val navigator = useContext(NavigationContext)
    val queryParams = useSearchParams()
    val regionId: Long? = queryParams.component1()["region"]?.toLongOrNull()
    val countryId: Long? = queryParams.component1()["country"]?.toLongOrNull()

    var products by useState(listOf<Product>())
    var title by useState("")
    var loadedRegion by useState<Long>()
    var loadedCountry by useState<Long>()
    var isLoading by useState(false)

    useEffectOnce {
        window.scroll(0.0, 0.0)
    }

    suspend fun loadData() {
        isLoading = true
        if (regionId != null && loadedRegion != regionId) {
            val data = ProductManager.getRegionProducts(regionId)
            products = data.products
            title = data.region.name.localized()
            loadedRegion = regionId
        } else if (countryId != null && loadedCountry != countryId) {
            val data = ProductManager.getCountryProducts(countryId)
            products = data.products
            title = data.country.name.localized()
            loadedCountry = countryId
        }
        isLoading = false
    }

    useEffect(regionId, countryId) {
        MainScope().launch {
            loadData()
        }
    }

    GenericPage {

        topFullWidthChildren = HeaderTitleView.create {
            this.title = title
        }

        if (isLoading) {
            VerticalLayout {
                sx {
                    minHeight = 300.px
                    justifyContent = JustifyContent.center
                    alignItems = AlignItems.center
                }
                CircularProgress()
            }
        }

        Box {
            sx {
                height = 4.px
            }
        }

        Grid {
            container = true
            spacing = responsive(12.px)

            products.forEach { product ->
                Grid {
                    item = true
                    xs = 12
                    sm = 6
                    md = 4
                    lg = 4

                    ProductItemView {
                        this.product = product
                        onClick = {
                            navigator.openProduct(product.id!!)
                        }
                    }
                }
            }
        }
    }
}